// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableFixHead {
    width: 100%;
}
.blue-background {
    background-color: lightcyan;
}

.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
  color: #fff;
  background-color: #17a2b8;
  border-color: #dee2e6 #dee2e6 #fff;
}
.nav-tabs .nav-link {
  color: #818182;
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8); /* White with some transparency */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050; /* Bootstrap's modal z-index is 1050 */
}
`, "",{"version":3,"sources":["webpack://./src/app/offer/offerlist/offerlist.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;AACA;IACI,2BAA2B;AAC/B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kCAAkC;AACpC;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0CAA0C,EAAE,iCAAiC;EAC7E,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,sCAAsC;AACvD","sourcesContent":[".tableFixHead {\r\n    width: 100%;\r\n}\r\n.blue-background {\r\n    background-color: lightcyan;\r\n}\r\n\r\n.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {\r\n  color: #fff;\r\n  background-color: #17a2b8;\r\n  border-color: #dee2e6 #dee2e6 #fff;\r\n}\r\n.nav-tabs .nav-link {\r\n  color: #818182;\r\n}\r\n\r\n.loader-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(255, 255, 255, 0.8); /* White with some transparency */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1050; /* Bootstrap's modal z-index is 1050 */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
